import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface MicroSite {
  id: string
  name: string
  logo: string
}

interface MicroSiteStore {
  microSite: MicroSite | null
  setMicroSite: (site: MicroSite) => void
  clearMicroSite: () => void
}

const useMicroSiteStore = create<MicroSiteStore>()(
  persist(
    (set) => ({
      microSite: null,
      setMicroSite: (site: MicroSite) => set({ microSite: site }),
      clearMicroSite: () => set({ microSite: null }),
    }),
    {
      name: 'micro-site-store',
      storage: {
        getItem: (name) => {
          if (typeof window === 'undefined') return null

          try {
            const item = sessionStorage.getItem(name)

            return item ? JSON.parse(item) : null
          } catch {
            return null
          }
        },
        setItem: (name, value) => {
          if (typeof window === 'undefined') return

          sessionStorage.setItem(name, JSON.stringify(value))
        },
        removeItem: (name) => {
          if (typeof window === 'undefined') return

          sessionStorage.removeItem(name)
        },
      },
    },
  ),
)

export default useMicroSiteStore
